var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"openModal":_vm.openModal}),_vm._v(" "),_c('b-modal',{attrs:{"size":"xl","title":"Add plan","hide-footer":""},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('onboarding-popup-payment-modal-container')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }